import { CheckIcon, DeleteIcon, EditIcon } from '@chakra-ui/icons'
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Button,
  Divider,
  Flex,
  FormControl,
  FormLabel,
  Input
} from '@chakra-ui/react'
import React, { ChangeEvent, FormEvent, useEffect, useRef, useState } from 'react'
import { formElementInterface, keyValue, keyValuePair } from '../lib/types'
import '@mdxeditor/editor/style.css'
interface notesInterface {
  notes: string
  id?: string
  is_active?: boolean
}
export const CreateNotes = ({
  onChangeCallBack,
  onEnterCallBack,
  formElementData,
  styleProps,
  labelProps,
  formattedDataCallBack,
  inputData
}: {
  onChangeCallBack: (e: ChangeEvent<Element>) => void
  onEnterCallBack?: (e: KeyboardEvent) => void
  chakraProps?: keyValue
  styleProps: keyValue
  formElementData: formElementInterface
  labelProps?: keyValue
  formattedDataCallBack: (formattedData: keyValuePair[]) => void
  inputData?: keyValuePair[]
}): JSX.Element => {
  const { placeHolder, title, validation, chakraProps, type, name, value, testId } = formElementData
  const [notes, setNotes] = useState<notesInterface[]>([])
  const [editableIndex, setEditableIndex] = useState<number | null>(null)
  const createNewNotes = (e: FormEvent): void => {
    const HTMLElement = e.currentTarget as HTMLFormElement
    const value = HTMLElement.value as string
    const newNotes: notesInterface[] = [...notes, { notes: value }]

    setNotes([...newNotes])

    const formattedNotes = newNotes.reduce(
      (reducer: notesInterface[], item: notesInterface) => [...reducer, { is_active: true, notes: item.notes, id: item.id }],
      []
    )

    formattedDataCallBack(formattedNotes as unknown as keyValuePair[])
    e.preventDefault()
  }

  const ref = useRef(null)
  const sendFormattednotes = (notes: notesInterface[]): void => {
    const formattedNotes = notes.reduce(
      (reducer: notesInterface[], item: notesInterface) => [...reducer, { is_active: true, notes: item.notes, id: item.id }],
      []
    )

    formattedDataCallBack(formattedNotes as unknown as keyValuePair[])
  }
  useEffect(() => {
    if (Array.isArray(inputData)) {
      const extractNotesString = inputData?.reduce(
        (reducer: notesInterface[], item: keyValuePair) => [...reducer, { notes: item.notes as string, id: item.id as string }],
        []
      )
      setNotes(extractNotesString ?? [])
      if (extractNotesString && extractNotesString.length > 0) {
        const formattedNotes = extractNotesString.map(item => ({ is_active: true, notes: item.notes, id: item.id }))
        formattedDataCallBack(formattedNotes as unknown as keyValuePair[])
      }
    }
  }, [])

  const notesHandleChange = (event: ChangeEvent<Element>, index: number): void => {
    const HTMLElement = event.currentTarget as HTMLInputElement
    const value = HTMLElement.value
    const updatedNotes = notes.reduce((reducer: notesInterface[], noteItem: notesInterface, noteIndex): notesInterface[] => {
      if (noteIndex !== index) {
        return [...reducer, { notes: noteItem.notes, id: noteItem.id }]
      }
      if (noteIndex === index) {
        return [...reducer, { notes: value, id: noteItem.id }]
      }
      return reducer
    }, [])
    sendFormattednotes(updatedNotes)
    setNotes(updatedNotes)
  }

  return (
    <>
      <FormControl {...styleProps} {...(formElementData.holderProps ?? {})}>
        <FormLabel {...labelProps}>
          {title} {validation?.required && <sup color="red">*</sup>}
        </FormLabel>
        <Input
          ref={ref}
          placeholder={placeHolder}
          data-testid={testId}
          type={type}
          name={name}
          height="80px"
          fontSize="14px"
          onChange={(e: ChangeEvent<Element>) => {
            onChangeCallBack(e)
          }}
          onKeyDown={e => {
            if (e.code === 'Enter') {
              createNewNotes(e)
              const currentElement = e.currentTarget
              currentElement.value = ''
            }
          }}
          defaultValue={typeof value === 'object' ? '' : (value as string)}
          variant={'outline'}
          {...(chakraProps ?? {})}
          {...(validation ?? {})}
        />
        {notes.length > 0 && (
          <Accordion mt="2" allowMultiple defaultIndex={0}>
            <AccordionItem>
              <h2>
                <AccordionButton>
                  <Box flex="1" textAlign="left">
                    More Notes
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
              </h2>
              <AccordionPanel pb={4}>
                {typeof notes === 'object' &&
                  notes.map((item: notesInterface, index) => (
                    <React.Fragment key={`Notes_${index}`}>
                      <Flex justifyContent={'space-betweens'} alignItems="center" fontSize={'12px'} width="100%" px="16px" py="4px">
                        <Box border="1px solid" borderColor={'gray.100'} borderRadius="8px" w="100%"></Box>
                        <Input
                          type="text"
                          width="100%"
                          borderWidth={editableIndex === index ? 1 : 0}
                          // eslint-disable-next-line no-unneeded-ternary
                          readOnly={editableIndex === index ? false : true}
                          value={item.notes}
                          onChange={event => notesHandleChange(event, index)}
                        />
                        <Button
                          onClick={() => {
                            if (editableIndex !== null) {
                              setEditableIndex(null)
                            }
                            if (editableIndex === null) {
                              setEditableIndex(index)
                            }
                          }}
                        >
                          {editableIndex === index && <CheckIcon />}
                          {editableIndex !== index && <EditIcon />}
                        </Button>
                        <Button
                          variant={'ghost'}
                          onClick={() => {
                            const updatedNotes = notes.reduce((reducer: notesInterface[], item, innerIndex) => {
                              if (innerIndex === index) {
                                return reducer
                              }

                              return [...reducer, item]
                            }, [])
                            sendFormattednotes(updatedNotes)

                            setNotes(updatedNotes)
                          }}
                        >
                          <DeleteIcon />
                        </Button>
                      </Flex>
                      {index < notes.length - 1 && <Divider />}
                    </React.Fragment>
                  ))}
              </AccordionPanel>
            </AccordionItem>
          </Accordion>
        )}
      </FormControl>
    </>
  )
}
